// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4a41bfb1","416":"65fd448d","441":"b4ac1c2c","578":"1316f6a9","622":"909ece56","739":"146b7987","977":"2899dd08"}[chunkId] + ".chunk.js";
};